import { DropdownOption } from '@core/models/models';

export const CORES_OPTIONS: DropdownOption[] = [
  { label: 'Branco', value: 'Branco' },
  { label: 'Preto', value: 'Preto' },
  { label: 'Cinzento', value: 'Cinzento' },
  { label: 'Prata', value: 'Prata' },
  { label: 'Azul', value: 'Azul' },
  { label: 'Vermelho', value: 'Vermelho' },
  { label: 'Verde', value: 'Verde' },
  { label: 'Amarelo', value: 'Amarelo' },
  { label: 'Castanho', value: 'Castanho' },
  { label: 'Bege', value: 'Bege' },
];

export const CALIBRES_OPTIONS: DropdownOption[] = [
  { label: '9mm', value: '9mm' },
  { label: '.38 Special', value: '.38 Special' },
  { label: '.40 S&W', value: '.40 S&W' },
  { label: '.45 ACP', value: '.45 ACP' },
  { label: '12 Gauge', value: '12 Gauge' },
  { label: '7.62mm', value: '7.62mm' },
  { label: '5.56mm', value: '5.56mm' },
];

export const FREQUENCIAS_VERIFICACAO_OPTIONS: DropdownOption[] = [
  { label: 'Di\u00e1ria', value: 'Diaria' },
  { label: 'Semanal', value: 'Semanal' },
  { label: 'Quinzenal', value: 'Quinzenal' },
  { label: 'Mensal', value: 'Mensal' },
  { label: 'Trimestral', value: 'Trimestral' },
];

export const SIM_NAO_OPTIONS: DropdownOption[] = [
  { label: 'Sim', value: 'true' },
  { label: 'N\u00e3o', value: 'false' },
];

export const PAISES_OPTIONS: DropdownOption[] = [
  { label: 'Angola', value: 'AO' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Brasil', value: 'BR' },
  { label: 'China', value: 'CN' },
  { label: 'Estados Unidos', value: 'US' },
  { label: 'R\u00fassia', value: 'RU' },
  { label: '\u00c1frica do Sul', value: 'ZA' },
  { label: 'Nam\u00edbia', value: 'NA' },
  { label: 'Rep\u00fablica Democr\u00e1tica do Congo', value: 'CD' },
  { label: 'Israel', value: 'IL' },
];

export const STATIC_SOURCES: Record<string, DropdownOption[]> = {
  CORES: CORES_OPTIONS,
  CALIBRES: CALIBRES_OPTIONS,
  FREQUENCIAS_VERIFICACAO: FREQUENCIAS_VERIFICACAO_OPTIONS,
  SIM_NAO: SIM_NAO_OPTIONS,
  PAISES: PAISES_OPTIONS,
};
